import ng from 'angular';

@Component('ib-MmB-gastronomic-proposal-module', 'ibPreSelectionSummary', {
    bindings: {
    },
    controller: PreSelectionSummaryComponent,
    controllerAs: 'preSelectionSummaryCtrl',
    templateUrl: ['MmBAppConstants', function (MmBAppConstants) {
        return MmBAppConstants.templatesRoute + 'ib-pre-selection-summary-view.html';
    }]
},
    [], [])
export class PreSelectionSummaryComponent implements ng.IController {
    model = {
        accordion: {
            menuOpen: true,
            specialOpen: true,
            other: true
        },
        messages: {
            loading: false,
            sended: false
        }
    }

    constructor() { }

    activate(): any {
    };

    showAnimation() {
        this.model.messages.loading = true;
        setTimeout(() => {
            this.model.messages.loading = false;
            this.model.messages.sended = true;
            setTimeout(() => {
                this.model.messages.sended = false;
            }, 2000)
        }, 3000);
    }

    $onInit = this.activate();
}
